export const ICON_CALENDAR = 'calendar';
export const ICON_BOOK = 'book';
export const ICON_MEAL = 'meal';
export const ICON_TRANSPORT = 'transport';
export const ICON_CROSS = 'cross';
export const ICON_DOTS = 'dots';
export const ICON_DOWN = 'down';
export const ICON_MINUS = 'minus';
export const ICON_PLUS = 'plus';
export const ICON_TIME = 'time';
export const ICON_UP = 'up';
export const ICON_WISHLIST = 'wishlist';
export const ICON_ARROW_LEFT = 'arrow_left';
export const ICON_ARROW_RIGHT = 'arrow_right';
export const ICON_WINNOW_LOGO = 'winnow-logo';
export const ICON_CODE = 'code';
export const ICON_PEOPLE = 'people';
export const ICON_INFO = 'info';
export const ICON_LOCATION = 'location';

export const ICONS_TYPES = [
  ICON_CALENDAR,
  ICON_BOOK,
  ICON_MEAL,
  ICON_TRANSPORT,
  ICON_CROSS,
  ICON_DOTS,
  ICON_DOWN,
  ICON_MINUS,
  ICON_PLUS,
  ICON_TIME,
  ICON_UP,
  ICON_WISHLIST,
  ICON_ARROW_LEFT,
  ICON_ARROW_RIGHT,
  ICON_WINNOW_LOGO,
  ICON_CODE,
  ICON_PEOPLE,
  ICON_INFO,
  ICON_LOCATION,
];
